<h3 mat-dialog-title>
   <i [class]="configModal.icon"></i><b>{{configModal.title | uppercase}}</b> <small> {{configModal.subtitle}}</small>
</h3>
<div mat-dialog-content>
    <!-- <h3 [innerHtml]="configModal.description"></h3> -->

    <div [ngSwitch]="dataModal.collection">

        <div *ngSwitchCase="'glaeria_post_facebook'">
            <div class="row">


                <div class="col-md-12 text-center" *ngIf="showVideo">
                    <p><b>Video</b></p>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>

                <div class="col-md-12">
                    <p><b>Pasos a seguir</b></p>
                    <ol>
                        <li>Crea una publicación "<b>de acceso público</b>" en Facebook y sube las fotos.</li>
                        <li>Una vez publicada, haz <b>click en la fecha de la publicación</b> para abrirla.</li>
                        <li>Copia la <b>URL completa</b> que aparece en la barra de direcciones del navegador.</li>
                        <li>Pega el link copiado en el campo <b>Link Facebook</b> de League Sports y haz click en guardar.</li>
                        <li>Si el link se copió correctamente, debe aparecer el preview de la publicación abajo del campo <b>Link Facebook</b>. Puede tomar unos segundos en cargar.</li>
                    </ol>
                </div>

                <div class="col-md-6">
                    <p><b>Fecha de publicación de post de Facebook</b></p>
                    <img src="assets/img/ayuda/galleria_share_fb_1.png" alt="Publicación de Facebook fecha" width="100%">
                </div>
                <div class="col-md-6">
                    <p><b>URL de publicación de post de Facebook</b></p>
                    <img src="assets/img/ayuda/galleria_share_fb_2.png" alt="Publicación de Facebook url" width="100%">
                </div>
            </div>
        </div>

        <div *ngSwitchCase="'video_post_facebook'">
            <div class="row">
                <div class="col-md-12 text-center" *ngIf="showVideo">
                    <p><b>Video</b></p>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>

                <div class="col-md-12">
                    <p><b>Pasos a seguir</b></p>
                    <ol>
                        <li>Ubicar la publicación del video en <a href="https://www.facebook.com/" target="_blank"></a><b>Facebook</b>.</li>
                        <li>Hacer click en la opción <b>Compartir</b>.</li>
                        <li>Hacer click en la opción <b>Copiar enlace</b>.</li>
                    </ol>
                </div>

                <div class="col-md-6">
                    <p><b>Copiar enlace de video de Facebook</b></p>
                    <img src="assets/img/ayuda/video_share_fb.png" alt="Copiar enlace de video de Facebook" width="100%">
                </div>
            </div>
        </div>

        <div *ngSwitchCase="'video_post_youtube'">
            <div class="row">
                <div class="col-md-12 text-center" *ngIf="showVideo">
                    <p><b>Video</b></p>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>

                <div class="col-md-12">
                    <p><b>Pasos a seguir</b></p>
                    <ol>
                        <li>Reproducir el video de <a href="https://www.youtube.com/" target="_blank"><b>YouTube</b></a>.</li>
                        <li>Hacer click en la opción <b>Compartir</b>.</li>
                        <li>Se muestra el enlace y se debe hacer click en el botón <b>Copiar</b>.</li>
                    </ol>
                </div>

                <div class="col-md-6">
                    <i>Copiar enlace de video de YouTube</i>
                    <img src="assets/img/ayuda/video_share_yt.png" alt="Copiar enlace de video de YouTube" width="100%">
                    
                </div>
            </div>
        </div>

        <div *ngSwitchCase="'video_post_web'">
            <div class="row">
                <div class="col-md-12 text-center" *ngIf="showVideo">
                    <p><b>Video</b></p>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>

                <div class="col-md-12">
                    <p><b>Pasos a seguir</b></p>
                    <ol>
                        <li>Abrir el video en el navegador web.</li>
                        <li>Copiar el link completo desde la <b>barra de direcciones</b>.</li>
                    </ol>
                </div>

                <!-- <div class="col-md-6">
                    <p><b>Copiar enlace de video de YouTube</b></p>
                    <img src="assets/img/ayuda/video_share_yt.png" alt="Copiar enlace de video de YouTube" width="100%">
                </div> -->
            </div>
        </div>

        <div *ngSwitchCase="'liga_torneos'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p>
                        <b>{{'Sección de Liga y Torneos' | uppercase}}</b>
                        <br>
                        En este video podrás ver un tutorial de las funciones de esta sección.
                    </p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'OPCIONES DE LA LIGA' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior de la sección, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-newspaper mr-1"></i>Noticias</button>: Accede a la sección de noticias de la liga.</li>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-flag mr-1"></i>Anuncios</button>: Accede a la sección de anuncios de la liga.</li>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-handshake mr-1"></i>Patrocinadores</button>: Accede a la sección de patrocinadores.</li>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-user-tie mr-1"></i>Árbitros</button>: Accede a la sección de registro de árbitros.</li>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-images mr-1"></i>Galerías</button>: Accede a la sección de galerías de la liga.</li>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-money-check-alt mr-1"></i>Plan</button>: Accede al estado de cuenta del Plan de tu Liga.</li>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-address-card mr-1"></i>Contacto</button>: Abre la ventana de contacto.</li>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-share-alt mr-1"></i>Sociales</button>: Abre la ventana para administrar las redes sociales de la liga.</li>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-image mr-1"></i>Logotipo</button>: Abre la ventada para modificar el logotipo de la liga.</li>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-image mr-1"></i>Portada</button>: Abre la ventana para modificar la portada de la liga.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Ajustes de la liga' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Accede a los ajustes principales de la liga.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-warning"><i class="fas fa-cog mr-1"></i>Ajustes</button>: Abre la ventana para administrar los ajustes de la liga. Dentro de los ajustes encontrarás más información.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Listado de torneos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Visualiza y crea torneos.</span>
                    </p>
                    <ul>
                        <li>
                            En el listado de torneos, has clic en el botón <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button> para desplegar las opciones:
                            <ul>
                                <li><b>Agregar torneo</b>: Crea un nuevo torneo. <b>La cantidad de torneos que puedes agregar depende del Plan de tu liga</b>.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Plan' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Información sobre el Plan de tu liga.</span>
                    </p>
                    <ul>
                        <li>Tu liga solo puede ser administrada si tu Plan está <b>vigente</b>, en caso que tengas un pago pendiente deberás realizarlo desde el botón <button class="btn btn-xs bg-olive"><i class="fas fa-money-check-alt mr-1"></i>Plan</button> para continuar administrando tu liga.</li>
                        <li>Puedes <b>cambiar de Plan</b> en cualquier momento, en la <b>sección de Plan</b> encontrarás más información.</li>
                        <li>Si no has realizado el pago de tu Liga, <b>la información siempre estará disponible en la Página Web de tu Liga</b>, pero no podrás actualizar los datos.</li>
                    </ul>
                </div>
                
            </div>
        </div>
        <div *ngSwitchCase="'torneo_temporadas'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p>
                        <b>{{'Sección de Torneo y Temporada' | uppercase}}</b>
                        <br>
                        En este video podrás ver un tutorial de las funciones de esta sección.
                    </p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'OPCIONES DEL TORNEO' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior de la sección, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-address-card mr-1"></i>Contacto</button>: Abre la ventana de contacto.</li>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-image mr-1"></i>Logotipo</button>: Abre la ventada para modificar el logotipo del torneo.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Ajustes del Torneo' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Accede a los ajustes principales del torneo.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-warning"><i class="fas fa-cog mr-1"></i>Ajustes</button>: Abre la ventana para administrar los ajustes del torneo. Dentro de los ajustes encontrarás más información.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Listado de Temporadas' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Visualiza y crea temporadas.</span>
                    </p>
                    <ul>
                        <li>
                            En el listado de temporadas, has clic en el botón <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button> para desplegar las opciones:
                            <ul>
                                <li><b>Agregar temporada</b>: Crea una nueva temporada. <b>No hay límite para crear temporadas</b>, pero consulta más información en la ventana y en las <b>Consideraciones de las Temporadas</b>.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Consideraciones de las temporadas' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Puntos importantes para tomar en cuenta.</span>
                    </p>
                    <ul>
                        <li>Puedes agregar todas la temporadas que necesites de tu torneo, pero solamente puedes tener <b>una temporada activa</b>. Para activar otra, tienes que finalizar la anterior.</li>
                        <li>Las <b>Temporadas finalizadas</b> ya no pueden ser modificadas, pero podrás acceder para consultar información; en la Página Web también se podrá visualizar la información de las Temporadas Finalizadas.</li>
                    </ul>
                </div>
                
            </div>
        </div>

        <div *ngSwitchCase="'temporada_fase_regular'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p>
                        <b>{{'Sección de Fase Regular de la Temporada' | uppercase}}</b>
                        <br>
                        En este video podrás ver un tutorial de las funciones de esta sección.
                    </p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'OPCIONES DE LA TEMPORADA' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior de la sección, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-info"><i class="fas fa-list mr-1"></i>Tipos</button>: Información de los tipos de torneo soportados y como configurarlos.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Ajustes de la Temporada' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Accede a los ajustes principales de la Temporada.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-warning"><i class="fas fa-cog mr-1"></i>Ajustes</button>: Abre la ventana para administrar los ajustes de la temporada. Dentro de los ajustes encontrarás más información.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Fase Regular' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Agrega y configura los grupos de la Fase Regular.</span>
                    </p>
                    <ul>
                        <li>
                            En está sección, has clic en el botón <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button> para desplegar las opciones:
                            <ul>
                                <li><b>Agregar grupos</b>: Crea un grupo nuevo. <b>Por defecto, siempre debe existir un grupo</b>. En la ventana podrás encontrar más información.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Consideraciones de las Fase Regular' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Puntos importantes para tomar en cuenta.</span>
                    </p>
                    <ul>
                        <li>Siempre debe existir un grupo.</li>
                        <li>Si la Temporada no va a tener <b>Fase de Grupos</b>, configúralo en los <b>Ajustes</b>. Consulta más información en los <b>Tipos de Torneo</b>.</li>
                        <li>Dentro de los grupos se administran los <b>equipos y partidos</b>. Consulta más información en las <b>opciones del grupo</b>.</li>
                    </ul>
                </div>
                
            </div>
        </div>

        <div *ngSwitchCase="'temporada_fase_final'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p>
                        <b>{{'Sección de Fase Final de la Temporada' | uppercase}}</b>
                        <br>
                        En este video podrás ver un tutorial de las funciones de esta sección.
                    </p>
                    <div width="100%" height="315" class="bg-secondary" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="100%" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>

                <div class="col-md-12 text-center" *ngIf="false">
                    <p>
                        <b>{{'Sección de Fase Final de la Temporada' | uppercase}}</b>
                        <br>
                        En este video podrás ver un tutorial de las funciones de esta sección.
                    </p>
                    <div width="360" height="115" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="260" height="115" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'OPCIONES DE LA TEMPORADA' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior de la sección, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-info"><i class="fas fa-list mr-1"></i>Tipos</button>: Información de los tipos de torneo soportados y como configurarlos.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Ajustes de la Temporada' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Accede a los ajustes principales de la Temporada.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-warning"><i class="fas fa-cog mr-1"></i>Ajustes</button>: Abre la ventana para administrar los ajustes de la temporada. Dentro de los ajustes encontrarás más información.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Fase Final' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Puntos importantes de la Fase Final.</span>
                    </p>
                    <ul>
                        <li>En la Fase final <b>no se pueden agregar grupos</b>.</li>
                        <li>
                            En esta fase, solamente existe un grupo por defecto en el que <b>se deben agregar los equipos calificados</b> a la Fase Final, con base en los siguientes puntos:
                            <ul>
                                <li>
                                    Si la Temporada <b>tiene Fase Regular</b>, solo se pueden agregar los equipos que participaron en la Fase Regular. Se mostrará un listado para seleccionarlos.
                                </li>
                                <li>
                                    Si la Temporada <b>no tiene Fase Regular</b>, se pueden crear todos los equipos que van a participar.
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <p>
                        <b>En la sección del grupo se podrá consultar más información sobre como agregar los equipos</b>.
                    </p>
                </div>

                
            </div>
        </div>

        <div *ngSwitchCase="'temporada_grupo'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p>
                        <b>{{'Sección de Grupo de la Temporada' | uppercase}}</b>
                        <br>
                        En este video podrás ver un tutorial de las funciones de esta sección.
                    </p>
                    <div width="100%" height="315" class="bg-secondary" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="100%" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'Ajustes del grupo' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Accede a los ajustes principales de .</span>
                    </p>
                    <ul>
                        <li>
                            Has clic en el botón <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button> para desplegar las opciones:
                            <ul>
                                <li><b>Editar grupos</b>: Elimina o modifica el grupo.</li>
                                <li><b>Agregar equipos</b>: Agrega los equipos que participarán en la Fase Final. Dentro de la opción encontrarás más información.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'OPCIONES DEL GRUPO Y EQUIPOS' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior del listado de equipos, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-chart-bar mr-1"></i>Estadísticas</button>: Consulta las estadísticas del grupo.</li>
                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-users mr-1"></i>Participantes</button>: Consulta los jugadores del grupo.</li>
                        <li><button class="btn btn-xs bg-olive"><i class="fas fa-calendar-day mr-1"></i>Partidos</button>: Ir a la sección de partidos del grupo.</li>
                    </ul>
                </div>

                

                <div class="col-md-12">
                    <p>
                        <b>{{'Listado de equipos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Opciones de los equipos.</span>
                    </p>
                    <ul>
                        <li>
                            En el listado se muestran todos los equipos que pertenecen al grupo, y tienen las siguientes opciones para administrarlos.
                            <ul>
                                <li><button class="btn btn-xs btn-outline-primary mr-1"><i class="fas fa-shield-alt"></i></button>: Opción rápida para actualizar el nombre del equipo.</li>
                                <li><button class="btn btn-xs btn-outline-primary mr-1"><i class="fas fa-image"></i></button>: Opción rápida para actualizar el logotipo del equipo.</li>
                                <li><button class="btn btn-xs btn-outline-primary mr-1"><i class="fas fa-user-plus"></i></button>: Opción rápida para agregar integrantes al equipo.</li>
                                <li><button class="btn btn-xs btn-outline-primary mr-1"><i class="fas fa-project-diagram"></i></button>: Opción rápida para cambiar de grupo al equipo.</li>
                                <li><button class="btn btn-xs btn-proliga mr-1"><i class="fas fa-external-link-alt"></i></button>: Opciones para compartir el link web del equipo.</li>
                                <li><button class="btn btn-xs btn-primary mr-1"><i class="fas fa-edit"></i></button>: Ventana de edición completa del equipo.</li>
                                <li><button class="btn btn-xs btn-danger mr-1"><i class="fas fa-times"></i></button>: Eliminar equipo del grupo (solo para Fase Final).</li>
                            </ul>
                        </li>
                        <li>
                            Has clic en el nombre del equipo para visualizar sus estadísticas.
                        </li>
                    </ul>

                    <p>
                        <b>Dentro de cada opción encontrarás más información</b>.
                    </p>
                </div>

                
            </div>
        </div>

        <div *ngSwitchCase="'partidos_regulares'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p><b>Sección de partidos regulares</b></p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <!-- <b>{{'EQUIPOS DEL GRUPO' | uppercase}}</b> -->
                        <!-- <br> -->
                        <span class="text-muted">En la parte superior de la sección, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li>
                            <button class="btn btn-xs bg-lightblue"><i class="fas fa-shield-alt mr-1"></i>Equipos</button>: Visualiza y edita los equipos que forman parte del grupo.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-lightblue"><i class="fas fa-users mr-1"></i>Participantes</button>: Visualiza y edita los integrantes de los equipos que forman parte del grupo.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-lightblue"><i class="fas fa-chart-bar mr-1"></i>Estadísticas</button>: Visualiza las estadísticas del grupo.
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Listado de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Se muestra el listado de partidos del grupo y las siguientes opciones.</span>
                    </p>
                    <ul>
                        <li>
                            <button class="btn btn-xs bg-primary mr-1"><i class="fas fa-list"></i></button><button class="btn btn-xs bg-primary mr-1"><i class="fas fa-th"></i></button>: Cambia la vista de los partidos, en listado o tarjetas.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button>: Visualiza las opciones de los partidos del grupo.
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Creación de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Opciones para crear partidos.</span>
                    </p>
                    <ul>
                        <li>
                            En el listado de partidos, has clic en el botón <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button> para desplegar las opciones:
                            <ul>
                                <li><b>Crear calendario automáticamente</b>: Genera el calendario completo de partidos, acomodados en jornadas.</li>
                                <li><b>Crear partidos posibles</b>: Crea todos los partidos posibles a jugar entre los equipos. Tendrás que distribuir manualmente los partidos en jornadas.</li>
                                <li><b>Crear segunda vuelta</b>: Cuando ya tienes el calendario, crea la segunda vuelta de todos los partidos.</li>
                                <li><b>Recalcular calendario</b>: Cuando ya tienes el calendario y quieres agregar nuevos equipos.</li>
                                <li><b>Agregar partido manualmente</b>: Agrega un partido.</li>
                                <li><b>Eliminar todos los partidos</b>: Elimina todos los partidos del grupo.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Filtrar partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Filtra partidos por palabras clave.</span>
                    </p>
                    <ul>
                        <li>En el buscador, escribe la palabra clave por la que quieres filtrar y presiona el botón <button class="btn btn-xs bg-secondary"><i class="fas fa-search"></i></button>.</li>
                        <li>Los partidos filtrados serán los que contengan <b>todas las palabras</b> que escribas.</li>
                        <li>Hay tres botones de busqueda rápida que puedes utilizar: <b>Semana</b>, <b>Hoy</b>, <b>Sin Jugar</b>.</li>
                        <li>En el botón <button class="btn btn-xs bg-light"><i class="fas fa-list"></i></button> puedes ver más opciones rápidas.</li>
                    </ul>
                </div>
                
                <div class="col-md-12">
                    <p>
                        <b>{{'Opciones rápidas de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Opciones visibles de los partidos del listado jornadas.</span>
                    </p>
                    <ul>
                        <li>
                            <button class="btn btn-xs bg-proliga mr-1"><i class="fas fa-clipboard"></i></button>: Registrar/Modificar el marcador del partido.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-calendar-day"></i></button>: Modificar la fecha y hora del partido. <b>Si el color es <span class="text-success"><b>verde</b></span>, quiere decir que tiene fecha y hora asignado</b>.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-images"></i></button>: Galería del partido. <b>Si el color es <span class="text-success"><b>verde</b></span>, quiere decir que tiene imágenes en la galería</b>.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-comment"></i></button>: Comentarios/observaciones del partido. <b>Si el color es <span class="text-success"><b>verde</b></span>, quiere decir que tiene comentarios</b>.
                        </li>
                        <!--<li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-share-alt"></i></button>: Link web del partido.
                        </li>-->
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-cog"></i></button>: Todos los ajustes del partido.
                        </li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Indicadores del partido' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior de un partido, pueden aparecer los siguientes indicadores.</span>
                    </p>
                    <ul>
                        <li><i class="fas fa-users text-warning mr-1"></i>: Tiene acciones de partido sin asignar.</li>
                        <li><i class="fas fa-video text-success mr-1"></i>: Tiene vinculado un link de video.</li>
                        <li><i class="fas fa-user-tie text-success mr-1"></i>: Tiene asignado un árbitro.</li>
                    </ul>
                    <p>
                        <b>Al hacer clic en los indicadores, puedes ver sus detalles</b>.
                    </p>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Modificar un grupo de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Modifica atributos generales a un grupo de partidos.</span>
                    </p>
                    <ul>
                        <li>Los partidos tienen una casilla <input type="checkbox"> en la parte izquierda, al activarla podrás seleccionar varios partidos para modificarlos.</li>
                        <li>Al activar una casilla, aparecerá la opción <button class="btn btn-xs text-primary"><i class="fas fa-edit mr-1"></i>Modificar seleccionados</button> con la cantidad de partidos seleccionados. Has clic para abrir las opciones.</li>
                        
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Intercambiar jornadas' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Cambia los partidos de una jornada por otra.</span>
                    </p>
                    <ul>
                        <li>En el listado de partidos de una jornada, presiona el botón <button class="btn btn-xs btn-primary"><i class="fas fa-exchange-alt"></i></button> para ver las opciones de intercambio de jornadas.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="'partidos_finales'">
            <div class="row" *ngIf="showVideo">
                <div class="col-md-12 text-center">
                    <p><b>Sección de partidos finales</b></p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <!-- <b>{{'EQUIPOS DEL GRUPO' | uppercase}}</b>
                        <br> -->
                        <span class="text-muted">En la parte superior de la sección, encontrarás los siguientes botones.</span>
                    </p>
                    <ul>
                        <li>
                            <button class="btn btn-xs bg-lightblue"><i class="fas fa-shield-alt mr-1"></i>Equipos</button>: Visualiza y edita los equipos que forman parte del grupo.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-lightblue"><i class="fas fa-users mr-1"></i>Participantes</button>: Visualiza y edita los integrantes de los equipos que forman parte del grupo.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-lightblue"><i class="fas fa-chart-bar mr-1"></i>Estadísticas</button>: Visualiza las estadísticas del grupo.
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Listado de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Se muestra el listado de partidos del grupo y las siguientes opciones.</span>
                    </p>
                    <ul>
                        <li>
                            <button class="btn btn-xs bg-primary mr-1"><i class="fas fa-list"></i></button><button class="btn btn-xs bg-primary mr-1"><i class="fas fa-th"></i></button>: Cambia la vista de los partidos, en listado o tarjetas.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button>: Visualiza las opciones de los partidos del grupo.
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Creación de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Opciones para crear partidos.</span>
                    </p>
                    <ul>
                        <li>
                            En el listado de partidos, has clic en el botón <button class="btn btn-xs bg-light"><i class="fas fa-wrench"></i></button> para desplegar las opciones:
                            <ul>
                                <li><b>Crear partidos finales</b>: Genera todas las llaves de la fase final automáticamente.</li>
                                <li><b>Ordenar equipos automáticamente</b>: Una vez generadas las llaves de fase final, ordena automáticamente los equipos con base en su posición del torneo regular.</li>
                                <li><b>Agregar partido manualmente</b>: Agrega un partido.</li>
                                <li><b>Eliminar todos los partidos</b>: Elimina todos los partidos del grupo.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Filtrar partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Filtra partidos por palabras clave.</span>
                    </p>
                    <ul>
                        <li>En el buscador, escribe la palabra clave por la que quieres filtrar y presiona el botón <button class="btn btn-xs bg-secondary"><i class="fas fa-search"></i></button>.</li>
                        <li>Los partidos filtrados serán los que contengan <b>todas las palabras</b> que escribas.</li>
                        <li>Hay tres botones de busqueda rápida que puedes utilizar: <b>Semana</b>, <b>Hoy</b>, <b>Sin Jugar</b>.</li>
                        <li>En el botón <button class="btn btn-xs bg-light"><i class="fas fa-list"></i></button> puedes ver más opciones rápidas.</li>
                    </ul>
                </div>
                
                <div class="col-md-12">
                    <p>
                        <b>{{'Opciones rápidas de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Opciones visibles de los partidos del listado jornadas.</span>
                    </p>
                    <ul>
                        <li>
                            <button class="btn btn-xs bg-proliga mr-1"><i class="fas fa-clipboard"></i></button>: Registrar/Modificar el marcador del partido.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-calendar-day"></i></button>: Modificar la fecha y hora del partido. <b>Si el color es <span class="text-success"><b>verde</b></span>, quiere decir que tiene fecha y hora asignado</b>.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-images"></i></button>: Galería del partido. <b>Si el color es <span class="text-success"><b>verde</b></span>, quiere decir que tiene imágenes en la galería</b>.
                        </li>
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-comment"></i></button>: Comentarios/observaciones del partido. <b>Si el color es <span class="text-success"><b>verde</b></span>, quiere decir que tiene comentarios</b>.
                        </li>
                        <!--<li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-share-alt"></i></button>: Link web del partido.
                        </li>-->
                        <li>
                            <button class="btn btn-xs bg-light mr-1"><i class="fas fa-cog"></i></button>: Todos los ajustes del partido.
                        </li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Indicadores del partido' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En la parte superior de un partido, pueden aparecer los siguientes indicadores.</span>
                    </p>
                    <ul>
                        <li><i class="fas fa-users text-warning mr-1"></i>: Tiene acciones de partido sin asignar.</li>
                        <li><i class="fas fa-video text-success mr-1"></i>: Tiene vinculado un link de video.</li>
                        <li><i class="fas fa-user-tie text-success mr-1"></i>: Tiene asignado un árbitro.</li>
                    </ul>
                    <p>
                        <b>Al hacer clic en los indicadores, puedes ver sus detalles</b>.
                    </p>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Modificar un grupo de partidos' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Modifica atributos generales a un grupo de partidos.</span>
                    </p>
                    <ul>
                        <li>Los partidos tienen una casilla <input type="checkbox"> en la parte izquierda, al activarla podrás seleccionar varios partidos para modificarlos.</li>
                        <li>Al activar una casilla, aparecerá la opción <button class="btn btn-xs text-primary"><i class="fas fa-edit mr-1"></i>Modificar seleccionados</button> con la cantidad de partidos seleccionados. Has clic para abrir las opciones.</li>
                        
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Otros ajustes de la Fase final' | uppercase}}</b>
                        <!-- <br> -->
                        <!-- <span class="text-muted"></span> -->
                    </p>
                    <ul>
                        <li>Para crear las llaves de fase final, no es necesario asignar equipos. Por lo que una vez generadas, podrás asignar los equipos haciendo clic en el botón <button class="btn btn-xs btn-outline-primary"><i class="fas fa-shield-alt"></i></button> de cada partido.</li>
                        <li>Si generas las llaves automáticamente estás se enlazan entre sí, por lo que en la opción <b>Generador de Llave</b> podrás elegir el ganador de la llave para pasarlo automáticamente a la siguiente llave.</li>
                        
                    </ul>
                </div>

            </div>
        </div>

        <div *ngSwitchCase="'registrar_marcador'">
            <div class="row" *ngIf="showVideo">

                <div class="col-md-12 text-center">
                    <p><b>Registrar marcadores</b></p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">

                <div class="col-md-12">
                    <p>
                        <b>{{'Agregar alineación' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Este paso es opcional, pero es recomendable para generar estadísticas a los participantes.</span>
                    </p>
                    
                    <ul>
                        <li>Para cada equipo, has clic en el botón de <b>Alineación</b> para abrir la ventana de alineación.</li>
                        <li>En la ventana de alineación, selecciona los integrantes del equipo que participaron en el partido.</li>
                        <li>Si un integrante aún no está registrado, deberás cerrar la ventana de alineación y agregarlo desde el botón <b>Equipo</b>. Luego regresa a la ventana de alineación para seleccionarlo.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Registro de acciones' | uppercase}}</b>
                        <br>
                        <span  class="text-muted">En este paso se ajusta el marcador del partido.</span>
                    </p>
                    <ul>
                        <li>Para cada <b>tipo de acción</b> has clic en los botones <button class="btn btn-xs btn-success"><i class="fas fa-plus"></i></button> ò <button class="btn btn-xs btn-danger"><i class="fas fa-minus"></i></button> para ajustar el valor deseado.</li>
                        <li>Cuando una acción tiene un valor mayor a 0, se agrega un registro en la sección de <b>Asignación de acciones</b> para asignar un integrante.</li>
                        <li>Los tipos de acciones disponibles dependen del <b>deporte</b> del torneo y la <b>configuración</b> de la temporada.</li>
                        <li>Si el partido ya finalizó las opciones de <b>Registro de Acciones</b> estarán ocultas, presiona el botón <b>Editar registro de acciones</b> para mostrarlos.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Asignación de acciones' | uppercase}}</b>
                        <br>
                        <span  class="text-muted">En este paso se vinculan las acciones registradas a los integrantes.</span>
                    </p>
                    <ul>
                        <li>Cuando se registra una acción, se agrega un registro <b class="text-warning">-- Sin aginar --</b>, lo que significa que no se ha vinculado un integrante.</li>
                        <li>
                            Has clic en la acción para abrir las opciones, las cuales se dividen en tres:
                            <ul>
                                <li><b>En alineación</b>: Filtra los integrantes que fueron agregados a la alineación en la sección <b>Agregar alineación</b>.</li>
                                <li><b>Todos</b>: Muestra todos los integrantes del equipo. Si seleccionas una opción de esta lista se agregará automáticamente a la alineación.</li>
                                <li><b>Sin asignar</b>: Esta opción no vincula a ningún integrante a la acción. Esta es la opción por defecto cuando se registra una nueva acción.</li>
                            </ul>
                        </li>
                        <li>Selecciona el integrante deseado.</li>
                        <li>
                            Puedes <b>ajustar la cantidad</b> de la acción con los botones <button class="btn btn-xs btn-success"><i class="fas fa-plus"></i></button> ò <button class="btn btn-xs btn-danger"><i class="fas fa-minus"></i></button> del registro, <b>solo para registros que tienen vinculado un integrante</b>:
                            <ul>
                                <li><b class="">Botón <button class="btn btn-xs btn-success"><i class="fas fa-plus"></i></button></b> <b> aumenta</b> una unidad a la acción por cada clic.</li>
                                <li>
                                    <b class="">Botón <button class="btn btn-xs btn-danger"><i class="fas fa-minus"></i></button></b> <b> disminuye</b> una unidad a la acción por cada clic. <b>Además puede realizar las siguientes acciones</b>:
                                    <ul>
                                        <li><b>Divide el registro en dos</b>: Por ejemplo, si tienes un registro de 5 goles asignado a un integrante, al pulsar el botón se descontará 1 al registro del integrante y se agregará uno nuevo sin asginar. Por lo que tendrías dos registros, uno de 4 goles para el integrante asignado y uno con 1 gol sin asignar.</li>
                                        <li><b>Aumenta el valor del registro <span class="text-warning">-- sin asignar --</span></b>: Siguiendo el ejemplo de arriba, si se sigue disminuyendo el valor del registro asignado, seguirá aumentando el valor del registro <span class="text-warning">-- Sin asignar --</span> hasta que se le asigne un integrante.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            Solo puede existir un registro de cada tipo para cada integrante. Es decir, si se un jugador ha anotado 3 goles, solo tendrá un registro del tipo goles, con la cantidad de 3.
                        </li>
                        <li>
                            Para eliminar el registro de la acción, has clic en el botón <button class="btn btn-xs btn-danger"><i class="fas fa-trash"></i></button>.
                        </li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Opciones del partido' | uppercase}}</b>
                        <!-- <br> -->
                        <!-- <span  class="text-muted">En este paso se vinculan las acciones registradas a los integrantes.</span> -->
                    </p>
                    <ul>
                        <li class="d-block d-sm-none">Abre las opciones del partido haciendo clic en el botón <button class="btn btn-xs btn-primary"><i class="fas fa-ellipsis-v"></i></button>.</li>
                        <li>Agrega imágenes a la <b>galería</b> del partido desde el botón <button class="btn btn-xs"><i class="fas fa-images"></i></button>.</li>
                        <li>Agrega <b>comentarios/observaciones</b> al partido desde el botón <button class="btn btn-xs"><i class="fas fa-comment"></i></button>.</li>
                        <li>Visualiza la <b>céudla</b> del partido desde el botón <button class="btn btn-xs"><i class="fas fa-clipboard"></i></button>. <b class="text-muted"><i>Solo para futbol</i></b></li>
                        <li>Accede a los <b>Ajustes del partido</b> desde el botón <button class="btn btn-xs"><i class="fas fa-cog"></i></button>.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Finalizar el partido' | uppercase}}</b>
                    </p>
                    <ul>

                        <li>Después que hayas registrado y asignado las acciones de partido, has clic en el botón <button class="btn btn-xs btn-success"><i class="fas fa-save mr-1"></i>Guardar</button> para guardar los cambios. El partido será <b>finalizado</b> y las <b>estadísticas</b> serán calculadas y actualizadas.</li>
                        <li>Después de finalizado, podrás seguir modificando cualquier opción del partido.</li>
                        <li>Si se modifican los marcadores del partido, o se cambia la asignación de una acción, <b>las estadísticas serán calculadas y actulizadas nuevamente</b> al guardar los cambios.</li>

                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'Otras opciones' | uppercase}}</b>
                    </p>
                    <ul>

                        <li>Para registrar integrantes, o editar un equipo, has clic en el botón <button class="btn btn-xs btn-proliga"><i class="fas fa-shield-alt"></i> Equipo</button> para abrirlo.</li>
                        <li>Puedes hacer clic en las alertas que se muestran para ver más información.</li>
                        <li>Si el partido ya ha sido finalzado aún puedes editarlo y guardarlo, se volverán a calcular las estadísticas.</li>
                        <li>Puedes <b>restaurar el partido</b>, desde los <b>Ajustes del partido</b>.</li>

                    </ul>
                </div>

            </div>
        </div>
        <div *ngSwitchCase="'registrar_marcador_alineaciones'">
            <div class="row" *ngIf="showVideo">

                <div class="col-md-12 text-center">
                    <p><b>Agregar alineaciones</b></p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'Agregar alineación' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Este paso es opcional, pero es recomendable para generar estadísticas a los participantes.</span>
                    </p>
                    <ul>
                        <li>Has clic en la opción <b>Selecciona un integrante</b> para abrir el listado de integrantes.</li>
                        <li>Selecciona los integrantes deseados para ir agregándolos a la alineación.</li>
                        <li>Para eliminar un integrante de la alineación, has clic en el botón <button class="btn btn-xs btn-danger"><i class="fas fa-trash"></i></button>. <b>Solo se pueden eliminar los integrantes que no tengan acciones de partido registradas</b>.</li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Registrar nuevos integrantes' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Si un integrante no está en el listado, registralo con los siguientes pasos.</span>
                    </p>
                    <ul>
                        <li>Cierra la ventana de Alineaciones.</li>
                        <li>Para el equipo que quieres registrar, has clic en el botón <button class="btn btn-xs btn-proliga"><i class="fas fa-shield-alt"></i> Equipo</button>.</li>
                        <li class="d-block d-sm-none">Has clic en el botón <button class="btn btn-xs bg-primary"><i class="fas fa-ellipsis-v"></i> Ajustes</button> para abrir las opciones.</li>
                        <li>Has clic en el botón <button class="btn btn-xs bg-lightblue"><i class="fas fa-users"></i> Integrantes</button>.</li>
                        <li>Has clic en el botón <button class="btn btn-xs bg-lightblue"><i class="fas fa-user-plus"></i> Agregar</button>.</li>
                        <li>Completa el formulario y guarda el integrante. Posteriormente, cierra las ventanas que se abrieron hasta regresar al partido y abre nuevamente la ventana de <b>Alineaciones</b>.</li>
                        <li>Realiza los pasos para <b>Agregar alineación</b>.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="'registrar_marcador_v3'">
            <div class="row" *ngIf="showVideo">

                <div class="col-md-12 text-center">
                    <p><b>Registrar marcadores</b></p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12 mb-4">
                    El asistente de partidos se divide en <b>4 pasos</b> para registrar el marcador del partido. Solamente el primer paso es obligatorio, pero es recomendable completar todos los pasos para una mejor administración del partido.
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'1. Resultado de partido' | uppercase}}</b>
                        <br>
                        <span class="text-muted">En este paso se registran las alineaciones y marcadores del partido.</span>
                    </p>

                    <p class="ml-3">
                        La primera opción es el botón <span><i class="fas fa-toggle-on"></i> Registrar alineación</span>. 
                        <br>
                        <b>Actívalo o desactívalo</b> dependiendo si vas a registrar alineación del equipo. 
                    </p>

                    <p class="ml-3">
                        <b>Si lo desactivas</b>, se mostrarán unicamente las opciones para agregar acciones de partido (anotaciones, terjetas, etc.) sin asiganarlas a jugadores.
                    </p>


                    <p class="ml-3">
                        <b>Si lo activas</b>, se mostrará el botón <b>+ Agregar</b> para abrir la ventana de integrantes.
                        <br>
                        Será obligatorio agregar alineación al equipo para poder continuar.
                        <br>
                        Conforme vayas agregando integrantes, irá apareciendo la alineación en las categorías de <b>Jugadores</b> ó <b>Cuerpo Técnico</b>, según corresponda. 
                        <br>
                        Cada registro de alineación tendrá sus opciones para agregar acciones de partido (anotaciones, terjetas, etc.)
                    </p>
                    <p class="ml-3">
                        Cada modificación en los marcadores se irá actualizando en el resultado de la parte superior de la ventana, en donde se muestra el nombre de los equipos.
                    </p>

                    <p class="ml-3">
                        Una vez que hayas terminado de configurar el resultado, has clic en el botón siguiente. Si hay alguna configuración pendiente, tendrás que completarla para poder avanzar.
                    </p>

                    
                    
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'2. Comentarios' | uppercase}}</b>
                        <br>
                        <span  class="text-muted">Agrega comentarios al partido. Este paso es opcional y puedes saltarlo haciendo clic en el botón <b>siguiente</b>.</span>
                    </p>
                    <ul>
                        <li>Has clic en el botón <b>+ Agregar</b> para añadir un nuevo comentario.</li>
                        <li>Completa el campo <b>Comentario *</b>.</li>
                        <li>Para borrar el comentario, has clic en el botón <i class="fas fa-trash text-danger"></i>.</li>
                    </ul>
                    <p>Los comentarios son visibles para todos desde la sección del partido en la página web y aplicación móvil</p>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'3. Acciones de fin de partido' | uppercase}}</b>
                        <br>
                        <span  class="text-muted">Configura acciones a realizar después de que el partido finalice. Este paso es opcional y puedes saltarlo haciendo clic en el botón <b>siguiente</b>.</span>
                    </p>
                    <p>
                        Dependiendo el tipo de partido, se pueden presentar algunas o todas las opciones que se listan:
                    </p>
                    <ul>
                        <li><b>Notificar en la App Móvil</b>: Si está activado, cuando finalices el partido se enviará una notificación a la aplicación móvil. Solo los usuarios que siguen el torneo la recibirán.</li>
                    </ul>
                </div>

                <div class="col-md-12">
                    <p>
                        <b>{{'4. Confirmación' | uppercase}}</b>
                        <br>
                        <span  class="text-muted">Revisa y confirma el fin del partido.</span>
                    </p>
                    <p>
                        En este paso se muestra un resumen de todo lo configurado en los pasos anteriores. Puedes modificar algúna configuración regresando al paso que deseas.
                        <br>
                        Una vez validada la información, has clic en el botón <b class="text-success">Confirmar</b> para guardar los datos del partido.
                    </p>
                </div>

            
                <div class="col-md-12 mt-2">
                    <p>
                        <b>{{'Otras opciones' | uppercase}}</b>
                    </p>
                    <p>
                        En parte superior de la ventana, se muestran las siguientes opciones:
                    </p>
                    <ul>

                        <li><button class="btn btn-xs bg-lightblue"><i class="fas fa-images"></i></button> Abre la ventana para añadir imágenes al partido.</li>
                        <li><button class="btn btn-xs btn-dark"><i class="fas fa-clipboard"></i></button> Visualiza la cédula del partido.</li>
                        <li><button class="btn btn-xs btn-primary"><i class="fas fa-cog"></i></button> Abre la ventana para ver los ajustes del partido.</li>


                    </ul>
                </div>

            </div>
        </div>
        <div *ngSwitchCase="'registrar_marcador_alineaciones_v3'">
            <div class="row" *ngIf="showVideo">

                <div class="col-md-12 text-center">
                    <p><b>Agregar alineaciones</b></p>
                    <div width="560" height="315" style="min-height: 315px; min-width: 560px;" class="bg-light" *ngIf="loadingVideo">
                        Cargando video
                        <br>
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <iframe [hidden]="loadingVideo" width="560" height="315" src="https://www.youtube.com/embed/ncWgndvJUjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen (load)="onLoadVide()" (error)="onErrorVideo()"></iframe>
                </div>
            </div>

            <div class="row" *ngIf="!loadingVideo">
                <div class="col-md-12">
                    <p>
                        <b>{{'Agregar alineación' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Este paso es opcional, pero es recomendable para generar estadísticas a los participantes.</span>
                    </p>
                    <ul>
                        <li>Has click en el botón <b class="text-success">+ Agregar</b> para añadir un integrante a la alineción.</li>
                        <li>Para eliminar un integrante de la alineación, se debe realizar desde el listado de alineación del equipo.</li>
                        <li>Puedes añadir todos los integrantes haciendo clic en el botón <i class="fas fa-wrench"></i> para abrir el menú de opciones. Posteriormente, has clic en la opción <b>Agregar todos</b></li>
                    </ul>
                </div>
                <div class="col-md-12">
                    <p>
                        <b>{{'Registrar nuevos integrantes' | uppercase}}</b>
                        <br>
                        <span class="text-muted">Si un integrante no está en el listado, regístralo con los siguientes pasos.</span>
                    </p>
                    <ul>
                        <li>Has clic en el botón <i class="fas fa-wrench"></i> para abrir el menú de opciones.</li>
                        <li>Has clic en la opción <b>Nuevo Jugador</b> ó <b>Nuevo Cuerpo Técnico</b>.</li>
                        <li class="d-block d-sm-none">Has clic en el botón <button class="btn btn-xs bg-primary"><i class="fas fa-ellipsis-v"></i> Ajustes</button> para abrir las opciones.</li>
                        <li>Se abrirá el formulario para agregar un nuevo integrante. Completa el formulario y el integrante se añadirá al listado de opciones.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div *ngSwitchDefault>
            <div class="alert">
                <i class="fas fa-exclamation-triangle mr-1"></i> Error en la configuración del modal.
            </div>
        </div>
    </div>    
</div>

<div mat-dialog-actions class="d-flex justify-content-between">
    <button class="btn btn-sm btn-secondary" (click)="close()"><i class="fas fa-times mr-1"></i>{{configModal.buttons.close.title}}</button>
</div>